<template>
    <div class="d-inline">
        <template v-if="withSlot">
            <div :class="'form-group ' + className">
                <label>
                    {{ $t(label) }}
                    <i
                        v-show="!disabled"
                        :class="iconClass"
                        style="font-size: .80rem !important;"
                        :id="id"
                    ></i>
                </label>
                <b-tooltip
                    :disabled.sync="disabled"
                    :target="id"
                    :placement="placement"
                    triggers="hover"
                    :animation="false"
                    no-fade
                    :delay="0"
                >{{ noTranslate ? label : $t(label + '_tooltip') }}</b-tooltip>
                <slot />
            </div>
        </template>
        <template v-else-if="!disabled">
            <i :class="iconClass" style="font-size: .80rem !important;" :id="`no_slot${id}`"></i>
            <b-tooltip
                :target="`no_slot${id}`"
                :placement="placement"
                triggers="hover"
                :animation="false"
                no-fade
                :delay="0"
            >{{ noTranslate ? label : $t(label + '_tooltip') }}</b-tooltip>
        </template>
    </div>
</template>

<script>
export default {
	props: {
		placeholder: [String, Array],
		label: {
			type: String,
			required: true,
			default: () => '',
		},
		disabled: {
			type: Boolean,
			default: () => false,
		},
		error: {
			type: Boolean,
			default: () => false,
		},
		noTranslate: {
			type: Boolean,
			default: () => false,
		},
		placement: {
			type: String,
			default: () => 'right',
		},
		className: {
			type: String,
			default: () => '',
		},
		withSlot: {
			type: Boolean | Number,
			default: () => true,
		},
	},
	data() {
		return {}
	},
	computed: {
		id() {
			return 'ic' + id()
		},
		iconClass() {
			return this.error ? 'icon-eye' : 'icon-question' + ' icons '
		},
	},
	methods: {
		//
	},
	mounted() {
		// this.withSlot = this.$slots && this.$slots.default && this.$slots.default.length
	},
}
</script>
